<template>
    <vx-card class="limited-max-width" id="third-step">
        <div>
          <header-step-process-component
          v-bind:step="step">
          </header-step-process-component>

          <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Iniciamos la contratación del seguro.</span>
          <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;"> Los datos que te solicitamos son necesarios para tramitar la solicitud con la compañía.</span>

          <forms-repository
              v-bind:code="code"
              v-bind:next="next"
              v-bind:previus="previus"
              v-bind:offerType="offerType"

              v-bind:formFilter="formFilter"
              v-bind:sendForm="sendForm"
              >
          </forms-repository>
          
        </div>
    </vx-card>
</template>
<script>
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue'
import formsRepository from '../forms/e-prevision-forms/forms-repository.vue'
/* eslint-disable */
export default {
  components: { formsRepository, HeaderStepProcessComponent },

  data() {
      return {
        step: 3,
        code: this.$route.params.code,
        next: "commercial-offer/fourth",
        previus: "commercial-offer/second",
        offerType: "commercial-offer",

        formFilter: "insuredForm",
        callServicePopup: false,
        cookieSavedInitialData: null,
        cookieSavedToken: null
      }
  },
  
  created(){
      this.$vs.loading.close()
    
  },
  methods: {
      sendForm(value) {
      },
  }
    
}
</script>

<style lang="scss">

</style>
